import React from "react";
import { useLocation } from "react-router-dom";

const PaymentStatus = () => {
  const location = useLocation();

  // Example: /payment-status?status=success OR failed
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get("status");

  // const isSuccess = status === "success";

  const isSuccess = true;

  return (
    <div className={`status-container ${isSuccess ? "success-bg" : "failed-bg"}`}>
      <div className="card">
        <div className={`icon ${isSuccess ? "success" : "failed"}`}>
          {isSuccess ? "✓" : "✕"}
        </div>

        <h1>
          {isSuccess ? "Payment under processing" : "Payment Failed"}
        </h1>

        <p>
          {isSuccess
            ? "ট্রাঞ্জেকশন প্রসেসিং হয়েছে কিছুহ্মন এর ভিতর অটো আপডেট হয়ে যাবে। ধন্যবাদ."
            : "Oops! Something went wrong. Your payment could not be processed."}
        </p>

        <div className="btn-group">
          {!isSuccess && (
            <button
              className="retry-btn"
              onClick={() =>
                (window.location.href = `https://${window.location.hostname}/bank/deposit`)
              }
            >
              Retry Payment
            </button>
          )}

          <button
            className="home-btn"
            onClick={() => {

              window.location.href =`https://${window.location.hostname}/`
              // window.location.reload();

            }}
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentStatus;